/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs/Observable';

import { PatientPortalStatementMenu } from '../model/patientPortalStatementMenu';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { environment } from '../../environments/environment';
import { VisitSummaryParams } from '../model/models';

@Injectable()
export class GetVisitSummaryService {

    protected basePath = environment.appSetting.apiUrl +'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.GetPatientPortalStatementMenu
     * This API get PatientPortalStatementMenu
     * @param patientId patient Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public GetVisitSummary(vsParams: VisitSummaryParams, observe?: 'body', reportProgress?: boolean): Observable<Array<any>>;
    public GetVisitSummary(vsParams: VisitSummaryParams, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<any>>>;
    public GetVisitSummary(vsParams: VisitSummaryParams, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<any>>>;
    public GetVisitSummary(vsParams: VisitSummaryParams, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

      

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

   
        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            // formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (vsParams.visitSlip !== undefined) {
            formParams = formParams.append('visitSlip', <any>vsParams.visitSlip) || formParams;
        }
        if (vsParams.serviceType !== undefined) {
            formParams = formParams.append('serviceType', <any>vsParams.serviceType) || formParams;
        }
        if (vsParams.approval_id !== undefined) {
            formParams = formParams.append('approval_id', <any>vsParams.approval_id) || formParams;
        }
        if (vsParams.patientId !== undefined) {
            formParams = formParams.append('patientId', <any>vsParams.patientId) || formParams;
        }
        if (vsParams.locationId !== undefined) {
            formParams = formParams.append('locationId', <any>vsParams.locationId) || formParams;
        }


        if (vsParams.userId !== undefined) {
            formParams = formParams.append('userId', <any>vsParams.userId) || formParams;
        }
       
        if (vsParams.ApprovalName !== undefined) {

            formParams = formParams.append('ApprovalName', <any>vsParams.ApprovalName) || formParams;
        }
        if (vsParams.approvalDate !== undefined) {
            formParams = formParams.append('approvalDate', <any>vsParams.approvalDate) || formParams;
        }

        if (vsParams.PracticeHeader !== undefined) {
            formParams = formParams.append('PracticeHeader', <any>vsParams.PracticeHeader) || formParams;
        }
        if (vsParams.PtName !== undefined) {
            formParams = formParams.append('PtName', <any>vsParams.PtName) || formParams;
        }
        if (vsParams.PtDOB !== undefined) {
            formParams = formParams.append('PtDOB', <any>vsParams.PtDOB) || formParams;
        }
        if (vsParams.visitDate !== undefined) {
            formParams = formParams.append('visitDate', <any>vsParams.visitDate) || formParams;
        }

        
        

        return this.httpClient.post<Array<any>>(`${this.basePath}/VisitSummary`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
               // params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
